// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"33bfaf5c","701":"ef5b438f","707":"66e39f04"}[chunkId] + ".chunk.js";
};